var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrice2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3759 3.59988C24.1986 2.77723 24.1986 1.4396 23.3759 0.616953C22.5533 -0.205692 21.2157 -0.205692 20.393 0.616953L15.7206 5.29603H9.75418L0.00714111 15.0357L6.96796 21.9965L16.728 12.2501V6.28354L17.9569 5.04116C19.332 5.95034 21.1895 5.78627 22.3816 4.59423L23.3759 3.59988ZM11.5368 13.4504L10.5425 12.4561C10.8165 12.1815 10.8165 11.7358 10.5425 11.4611C10.2692 11.1878 9.82145 11.1871 9.54816 11.4618C9.27416 11.7358 9.27416 12.1815 9.54816 12.4561C10.3708 13.2788 10.3708 14.6164 9.54816 15.439C8.97617 16.011 8.0743 16.2666 7.16221 15.8357L6.0674 16.9305L5.07309 15.9362L6.16842 14.8408C5.79992 14.0583 5.91922 13.1024 6.56388 12.4561L7.55954 13.4504C7.28555 13.7244 7.28555 14.1707 7.55954 14.4447C7.83354 14.7201 8.27986 14.7187 8.55385 14.4447C8.82785 14.1707 8.82785 13.7244 8.55385 13.4504C7.73121 12.6278 7.73121 11.2894 8.55385 10.4668C9.20071 9.82111 10.1568 9.70191 10.939 10.0703L12.0339 8.9754L13.0282 9.96971L11.9335 11.0644C12.3027 11.8476 12.1831 12.8041 11.5368 13.4504ZM18.986 4.01188L21.3873 1.61126C21.662 1.33661 22.107 1.33661 22.3816 1.61126C22.6556 1.88526 22.6556 2.33157 22.3816 2.60557L21.3873 3.59988C20.7384 4.2488 19.7702 4.38615 18.986 4.01188Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1343 7.53886V12.8325L9.14669 21.8064L9.02832 22.7748L18.8032 24L20.4312 10.4785L18.1343 7.53886Z",
    fill: "#7F7F7F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice2);
export default __webpack_public_path__ + "static/media/price2.e2d9ad99fb23a5d33be7530a28f2c6e9.svg";
export { ForwardRef as ReactComponent };